import * as React from 'react';
import type { ColumnProvider } from '../../index';
import { observer } from 'mobx-react-lite';
import TimeMarkerBaseContent from './TimeMarkerBaseContent';

const styles = require('./TimeMarker.scss');

/**
 * Component that shows a line in the position of the current time on the calendar day and week views
 */
export default observer(function TimeMarkerTodayContent({
    columnProvider,
}: {
    columnProvider: ColumnProvider;
}) {
    return (
        <TimeMarkerBaseContent
            columnProvider={columnProvider}
            className={styles.currentDayMarker}
            zIndex={2}
        />
    );
});
